import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective } from 'ngx-mask';

import { PaymentCustomSpreadComponent } from './payment-custom-spread.component';
import { MatDialogCustomModule } from '@shared/mat-dialogs/mat-dialog-custom/mat-dialog-custom.module';
import { PreventScrollDirective } from '@shared/prevent-scroll-directive/prevent-scroll.directive';

@NgModule({
  declarations: [PaymentCustomSpreadComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslateModule,
    MatDialogCustomModule,
    NgxMaskDirective,
    PreventScrollDirective,
  ],
  exports: [PaymentCustomSpreadComponent],
})
export class PaymentCustomSpreadModule {}
